"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stickyHeader = void 0;
const stickyHeader = () => {
    const header = document.querySelector('header.site-header');
    const body = document.querySelector('body');
    window.addEventListener('scroll', function (e) {
        let offset = 0;
        if (window.innerWidth >= 1001) {
            offset += 125;
        }
        if (window.scrollY > offset) {
            header.classList.add('is-sticky');
            body.classList.add('header-sticky');
        }
        else {
            header.classList.remove('is-sticky');
            body.classList.remove('header-sticky');
        }
    });
};
exports.stickyHeader = stickyHeader;
